import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// @ts-ignore
import html2pdf from "html2pdf.js"
import { useSelector } from "react-redux";

interface DownloadProps {
  downloadapplication: any;
}

const ApplicationPreview: React.FC<DownloadProps> = ({
  downloadapplication,
}) => {
  const language = useSelector((state: any) => state.auth.language);
    const pdfRef = useRef<HTMLDivElement>(null);

    const downloadPDF = () => {
        if (pdfRef.current) {
          const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
          clonedContent.style.display = "block"; // Ensure content is visible in PDF
          html2pdf().from(clonedContent).set({
            margin: 10, // Add margin to avoid content clipping
            filename: `PanelEngineer_Application_${downloadapplication.applicationId}.pdf`,
            html2canvas: { scale: 4},  // Adjust the scale to fit content
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          })
        .save(`PanelEngineer_Application_${downloadapplication.applicationId}.pdf`);
        }
      };
 

  return (<>
    <div ref={pdfRef} style={{ display:"none",width:"100%" ,fontFamily: "Arial, sans-serif", padding: "10px" }}>
      <h3
        style={{
          textAlign: "center",
          textDecoration: "underline",
          fontWeight: "bold",
        }}
      >
        Appendix-“A” (New Application)
      </h3>
      <p
        style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}
      >
        Sample application for the inclusion of a new name as panel engineers
        for construction works of Agricultural Produce Market Committees.
      </p>
        <div className="row mb-4">
  <div className="col text-start mt-4">
    Application ID: {downloadapplication?.applicationId}
  </div>

  <div className="col text-end mt-4">
    Date:{" "}
    {downloadapplication?.appliedDate
      ? new Date(downloadapplication.appliedDate).toLocaleDateString()
      : "N/A"}
  </div>
</div>

      <div
        id="application-preview"
        style={{
          padding: "10px",
          border: "1px solid black",
          width: "90%",
          maxWidth: "700px", 
          margin: "auto", 
        }}
      >
        <table
          style={{
            width: "100%",
            minWidth: "600px", 
            borderCollapse: "collapse",
            tableLayout: "auto", 
            pageBreakInside: "auto",
            textAlign: "left",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
              <th
                style={{
                  border: "1px solid black",
                  width: "1%",
                  padding: "5px",
                }}
              >
                Sr no.
              </th>
              <th
                style={{
                  border: "1px solid black",
                  width: "3%",
                  padding: "5px",
                }}
              >
                Detail
              </th>
              <th
                style={{
                  border: "1px solid black",
                  width: "3%",
                  padding: "5px",
                }}
              >
                Detail
              </th>
              <th
                style={{
                  border: "1px solid black",
                  width: "1 %",
                  padding: "5px",
                }}
              >
                Attachment? (Yes/No)
              </th>
              <th
                style={{
                  border: "1px solid black",
                  width: "1%",
                  padding: "5px",
                }}
              >
                Page no.
              </th>
              <th
                style={{
                  border: "1px solid black",
                  width: "1%",
                  padding: "5px",
                }}
              >
                Remarks
              </th>
            </tr>
          </thead>
          <tbody >
            {[
              {
                srNo: 1,
                label:
                  "Name of the applicant (if it is a partnership firm, names of the partners)",
                value: `ApplicantName - ${downloadapplication?.applicantName} ${
                  downloadapplication?.partnerDetails && downloadapplication.partnerDetails.length > 0
                    ? `Partners Name: ${downloadapplication.partnerDetails.map((partner: any) => partner.partnerName).join(", ")}`
                    : ""
                }` || "N/A",
                attachment: downloadapplication?.partnerDetails?.some(
                  (partner: any) => partner.documentName 
                )
                  ? "Yes"
                  : "No",
              },
              
              {
                srNo: 2,
                label:
                  "Applicant’s full address/Office Address/Mobile Number/Authorized Email ID",
                value: `Applicants Full Address-${downloadapplication?.perAddress?.at} Post-${downloadapplication?.perAddress?.post} Taluka-${downloadapplication?.perAddress?.taluka}  District-${downloadapplication?.perAddress?.district} Registered Office Address-${downloadapplication?.regOffAddress?.at} Post-${downloadapplication?.regOffAddress?.post } Taluka-${downloadapplication?.regOffAddress?.taluka }  District-${downloadapplication?.regOffAddress?.district}` || "N/A",
                attachment: 
                (downloadapplication?.perAddress?.documentName && downloadapplication?.perAddress?.fileName) || 
                (downloadapplication?.regOffAddress?.documentName && downloadapplication?.regOffAddress?.fileName) 
                  ? "Yes" 
                  : "No", 
              },
              {
                srNo: 3,
                label: "Study-Educational Qualification (Attested copy to be attached)",
                value: downloadapplication?.eduQualification?.map((qualification: any) => {
                  return `Standard-${qualification.standard} DocumentName-(${qualification.documentName})`;
                }).join(", ") || "N/A",
                attachment: downloadapplication?.eduQualification?.some(
                  (qualification: any) => qualification.documentName && qualification.fileName
                )
                  ? "Yes"
                  : "No",
              },
              {
                srNo: 4,
                label: "Date of birth, showing age",
                value: downloadapplication?.dob
                  ? new Date(downloadapplication.dob).toLocaleDateString()
                  : "N/A",
              },
              {
                srNo: 5,
                label: "Giving details of experience (Attach a certified copy of the evidence for 5 years/4 years of experience)",
                value: downloadapplication?.experienceDetail?.map((experience: any) => {
                  const formattedExperience = `ProjectName-${experience.projectName} (Start date-${new Date(experience.startDate).toLocaleDateString()} End Date- ${new Date(experience.endDate).toLocaleDateString()}) Document Name-[${experience.eveidenceProof?.documentName}]`;
                  return formattedExperience;
                }).join(", ") || "N/A",
                attachment: downloadapplication?.experienceDetail?.some(
                  (experience: any) => experience.eveidenceProof?.fileName || experience.eveidenceProof?.documentName
                )
                  ? "Yes"
                  : "No",
              },
              
              {
                srNo: 6,
                label:
                  "How many years have you been working as a business engineer?",
                value: downloadapplication?.yrOfExpAsBusErr || "N/A",
              },
              {
                srNo: 7,
                label: "Details of any government or semi-government office work performed (Year by year project name)",
                value: downloadapplication?.govSemiGovExpDetail
                  ?.map((exp: any) => {
                   
                    const formattedExp = `${exp.projectName} (${new Date(exp.startDate).toLocaleDateString()} - ${new Date(exp.endDate).toLocaleDateString()}) [${exp.eveidenceProof?.documentName}]`;
                    return formattedExp;
                  })
                  .join(", ") || "N/A", 
                  attachment: downloadapplication?.govSemiGovExpDetail?.some(
                    (exp: any) => exp.eveidenceProof?.fileName || exp.eveidenceProof?.documentName
                  )
                    ? "Yes"
                    : "No",
              },
              
              {
                srNo: 8,
                label: "If construction has been done in the market committee and public institution, its details should be given along with the supporting documents",
                value: downloadapplication?.marketPublicConstructionDetail
                  ?.map((work: any) => {
                    
                    const formattedWork = `Project Name: ${work.projectName} (Start Date: ${new Date(work.startDate).toLocaleDateString()} End Date: ${new Date(work.endDate).toLocaleDateString()}) Document Name: [${work.eveidenceProof?.documentName}]`;
                    return formattedWork;
                  })
                  .join(", ") || "N/A",
                attachment: downloadapplication?.marketPublicConstructionDetail?.some(
                  (work: any) => work.eveidenceProof?.fileName || work.eveidenceProof?.documentName
                )
                  ? "Yes"
                  : "No",
              },
              
              {
                srNo: 9,
                label: "IT returns for the last three years",
                value: (downloadapplication?.itReturnDetail)  && downloadapplication.itReturnDetail.length > 0  ? "Available" : "Not Submitted",
                attachment:
                downloadapplication?.itReturnDetail?.some((doc: any) => doc.documentName === "itReturns_1") &&
                downloadapplication?.itReturnDetail?.some((doc: any) => doc.documentName === "itReturns_2") &&
                downloadapplication?.itReturnDetail?.some((doc: any) => doc.documentName === "itReturns_3")
                  ? "Yes"
                  : "No",
              }
              
            ].map((row, index) => (
              <tr key={index} style={{ breakInside: "avoid", pageBreakInside: "avoid" }}>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  {row.srNo}
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  {row.label}
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  {row.value}
                </td>
                <td
        style={{
           breakInside: "avoid",
          pageBreakInside: "avoid",
          border: "1px solid black",
          padding: "5px",
          textAlign: "center",
        }}
      >
        {row.attachment} 
      </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                  }}
                >
                  -
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                  }}
                >
                  -
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p
        style={{
          fontWeight: "bold",
          textDecoration: "underline",
          marginTop: "20px",
        }}
      >
        Candidate’s certificate
      </p>
      <p>
        (1) We understand that all the conditions included in the Director’s
        order are binding on us.
      </p>
      <p>
        (2) Any action taken for breach of the terms and conditions will be
        acceptable to us.
      </p>
      <p>
        (3) If we/our firm/agency are blacklisted by any other government
        institution/agency, we will immediately inform the office of the
        Director of Agriculture Marketing & Rural Finance, Government of
        Gujarat, Gandhinagar. Thereafter, we/our firm will not carry out any
        work related to the panel engineer in any market committee. We hereby
        assure this.
      </p>

      <p style={{ textAlign: "right", marginTop: "40px", fontWeight: "bold" }}>
        Candidate’s signature
      </p>

     
    </div>
     <div style={{ marginTop: "20px", textAlign: "center" }}>
     <button
       onClick={downloadPDF}
       style={{
         padding: "10px 20px",
         fontSize: "16px",
         cursor: "pointer",
         backgroundColor: "#007bff",
         color: "white",
         border: "none",
         borderRadius: "5px",
       }}
     >
       {language.down_pdf}
     </button>
   </div>
   </>
  );
};

export default ApplicationPreview;
